import React from 'react';
import SectionHeader from '../common/SectionHeader';

class ReportList extends React.Component {
  render() {
    return (
      <React.Fragment>
        <SectionHeader title="Reports" />
      </React.Fragment>
    );
  }
}

export default ReportList;



// WEBPACK FOOTER //
// ./src/components/reports/ReportList.js